export class Municipio {
  id: string;
  nome: string;
  sigla: string;
  nomeCompleto: string;
  idTipoAreaGeografica: number;
}
